export enum NavigationStyle {
  default = 'default',
  dark = 'dark-mode',
  transparentDark = 'transparent-dark',
  transparentLight = 'transparent-light',
}
